'use strict';
import {isCordovaBuild} from '../config/constants';
import invitationLoginTemplate from './controllers/invitation-login.html';
import invitationRespondTemplate from './controllers/invitation-respond.html';
import loginTemplate from './controllers/login.html';
import mobileLoginTemplate from './controllers/mobile-login.html';
import setupCompleteOrgInviteAcceptedTemplate from './controllers/complete-org-invite-accepted.html';


export const authStates = {
  invitationLogin: 'invitation-login',
  invitationRespond: 'invitation-respond',
  login: 'login',
  mobileLogin: 'mobile-login',
  setupCompleteOrgInviteAccepted: 'setup-complete-org-invite-accepted',
};

export function getLoginView() {
  return isCordovaBuild() ? authStates.mobileLogin : authStates.login;
}

routerConfig.$inject = [
  '$stateProvider',
];

export function routerConfig(
  $stateProvider,
) {
  $stateProvider
    .state(authStates.login, {
      title: 'auth.login.title',
      url: '/login',
      template: loginTemplate,
      resolve: requiresAuthComplete(),
    })
    .state(authStates.mobileLogin, {
      title: 'auth.login.title',
      url: '/mobile-login',
      template: mobileLoginTemplate,
      resolve: requiresAuthComplete(),
    })

    // wire up referral stuff
    /* TODO: convert to search param instead of path. Will need to leave existing state def in place but deprecated */
    .state(authStates.invitationLogin, {
      title: 'auth.login.title',
      url: '/invitation-login/:accessCode',
      template: invitationLoginTemplate,
      controller: 'InvitationLoginController as inviteLogin',
      resolve: requiresAuthComplete(),
    })

    .state(authStates.invitationRespond, {
      title: 'auth.invite.referral.response.title',
      url: '/invitation-respond?accessCode',
      template: invitationRespondTemplate,
      controller: 'InvitationRespondController as inviteRespond',
      resolve: {
        currentUser: [
          'AuthService',
          'AppBootstrapper',
          (AuthService, AppBootstrapper) =>
            AuthService.initAuthComplete()
              .then(() => AppBootstrapper.loaded())
              .then(() => AuthService.getCurrentUser()),
        ],
      },
    })

    .state(authStates.setupCompleteOrgInviteAccepted, {
      title: 'onboarding.invite.accepted.header',
      url: '/setup/invitation/accepted',
      template: setupCompleteOrgInviteAcceptedTemplate,
      resolve: requiresAuthSuccess(),
    });
}

export function requiresAuthComplete() {
  return {
    authInit: [
      'AuthService',
      'AppBootstrapper',
      (AuthService, AppBootstrapper) =>
        AuthService.initAuthComplete()
          .then(() => AppBootstrapper.loaded())
          .catch((err) => null),
    ],
  };
}

export function requiresAuthSuccess() {
  return {
    authInit: withAuthSuccess(),
  };
}

export function withAuthSuccess() {
  return [
    'AuthService',
    'AppBootstrapper',
    (AuthService, AppBootstrapper) =>
      AuthService.initAuthComplete()
        .then(() => AppBootstrapper.loaded()),
  ];
}



// WEBPACK FOOTER //
// ./src/js/auth/router.js